import gql from 'graphql-tag';

export const ORDER_CREATE_COSTS = gql`
  query OrderCreateCosts($input: OrderCostsInput) {
    orderCosts(input: $input) {
      orderItemsCostsWithDetails {
        xProductId
        xRefTypeId
        quantity
        orderItemCost
        startDate
        endDate
        discount
        discountStartDate
        discountEndDate
        maxQuantityForDiscount
      }
      serviceFee
      stripeFee
      subtotal
      total
      discount
      globalDiscountAmount
      discountCodeApplied
      discountCodeError
      subtotalBeforeGlobalDiscount
    }
  }
`;
